require('./bootstrap');
import Vue from 'vue';
import vSelect from 'vue-select'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts);

Vue.component('apexchart', VueApexCharts);
Vue.component('v-select', vSelect);
Vue.component('pagination', require('laravel-vue-pagination'));


///Vue.component('house-calendar', require('./components/HouseCalendarOld.vue').default);
Vue.component('owner-properties-calendar', require('./components/OwnerPropertiesCalendar.vue').default);
Vue.component('owner-properties-document-riepilogativi', require('./components/OwnerPropertiesDocumentRiepilogativi.vue').default);
Vue.component('owner-properties-document-fatture', require('./components/OwnerPropertiesDocumentFatture.vue').default);
Vue.component('owner-properties-document-altro', require('./components/OwnerPropertiesDocumentAltro.vue').default);
Vue.component('house-calendar', require('./components/HouseCalendar.vue').default);
Vue.component('house-document-riepilogativi', require('./components/HouseDocumentRiepilogativi.vue').default);
Vue.component('house-document-fatture', require('./components/HouseDocumentFatture.vue').default);
Vue.component('house-document-altro', require('./components/HouseDocumentAltro.vue').default);
Vue.component('list-houses', require('./components/ListHouses.vue').default);
Vue.component('netto-proprietario', require('./components/NettoProprietario.vue').default);
Vue.component('numero-prenotazioni', require('./components/NumeroPrenotazioniProprietario.vue').default);
Vue.component('numero-notti', require('./components/NumeroNottiProprietario.vue').default);
Vue.component('house-cards', require('./components/HouseCardsHome.vue').default);


const app = new Vue({
    el: '#app',
});